import * as stylex from '@stylexjs/stylex'
import lottie from 'lottie-web'
import { useEffect, useRef } from 'react'

export interface LottieProps {
  /** Lottie 動畫 JSON 資料 */
  animationDataProps: unknown
  /** 自訂根元素的 StyleX 樣式 */
  rootStyle?: stylex.StyleXStyles
}

/**
 * Lottie 是 Lottie 動畫播放元件，使用 lottie-web 以 SVG 方式渲染。
 * 掛載時自動播放，卸載時自動銷毀。
 */
export const Lottie = ({ animationDataProps, rootStyle }: LottieProps) => {
  const lottieRef = useRef(null)

  useEffect(() => {
    if (!lottieRef.current) return
    const instance = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: 'svg',
      autoplay: true,
      animationData: animationDataProps,
    })
    return () => {
      instance.destroy()
    }
  }, [animationDataProps, lottieRef])

  return (
    <div ref={lottieRef} {...stylex.props(rootStyle)} />
  )
}
